import L from '../../../node_modules/leaflet/dist/leaflet';

// Define a custom icon
export const customIcon = L.icon({
  iconUrl: '/public/assets/V2/dist/images/pin.svg', // Replace with your custom pin image URL
  iconSize: [25, 35], // Size of the icon
  iconAnchor: [12.5, 35], // Point of the icon which will correspond to marker's location
  popupAnchor: [-3, -76] // Point from which the popup should open relative to the iconAnchor
});

export function initializeMap() {

  // Initialize the map and set its view to a specific location and zoom level
  const map = L.map('map').setView([51.505, -0.09], 2);

  // Add a tile layer to the map (OpenStreetMap tiles)
  L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png', {
    attribution: '© OpenStreetMap contributors'
  }).addTo(map);

  return map
}

export function addNewMarker(lat, long, icon, tooltip, mapL) {
  return L.marker([lat, long], { icon })
    .addTo(mapL)
    .bindTooltip(tooltip)
  // .openPopup();
}

export async function getCampuses(name, value) {

  const formData = new FormData();
  // formData.append('slug', schoolSlug);
  formData.append(name, value);

  return fetch('/schools/index/getCampuses', {
    method: "POST",
    mode: "cors",
    credentials: "same-origin",
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: formData
  })
}

export function createNewCampusBox(country, city, address, lat, long, mapL) {

  const campusWrapper = document.querySelector('.campuss-box');
  const campusBox = document.createElement('div');
  const campusTextBox = document.createElement('div');
  const campusLocation = document.createElement('p');
  const campusAddress = document.createElement('p');

  campusBox.classList = 'campuss flexy x-start y-start';
  campusTextBox.classList = 'text';
  campusLocation.classList = 'location';
  campusAddress.classList = 'adress';

  campusLocation.textContent = `${city}, ${country}`;
  campusAddress.textContent = address;

  campusTextBox.appendChild(campusLocation);
  campusTextBox.appendChild(campusAddress);
  campusBox.appendChild(campusTextBox);

  campusBox.addEventListener('click', function (e) {
    mapL.setView([lat, long], 8);
  })

  campusWrapper.appendChild(campusBox);

  return campusWrapper
}